// extracted by mini-css-extract-plugin
module.exports = {"submenuItem":"SubmenuItem_submenuItem__xhCc0","imageWrapper":"SubmenuItem_imageWrapper__XOzAe","image":"SubmenuItem_image__LR6oV","title":"SubmenuItem_title__NWxOD"};